import React, { useState, useEffect } from 'react';
import {
  SliderContainer,
  SliderTrack,
  SliderProgress,
  SliderThumb,
  SliderInputContainer,
  StackContainer,
} from './SliderInput.styles';
import Typography from 'src/app/atoms/Typography/Typography';

export interface SliderInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  label?: string;
}

const SliderInput: React.FC<SliderInputProps> = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  className,
  label,
}) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const newPercentage = ((value - min) / (max - min)) * 100;
    setPercentage(newPercentage);
  }, [value, min, max]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      const newValue = Number(e.target.value);
      onChange(newValue);
    }
  };

  return (
    <StackContainer
      direction='column'
      gap='spacing-sm'
      className={className}
    >
      {label && (
        <Typography
          type='paragraph'
          size='sm'
          color='text-secondary'
        >
          {label}
        </Typography>
      )}
      <SliderContainer>
        <SliderTrack>
          <SliderProgress $value={percentage} />
          <SliderThumb $value={percentage} />
        </SliderTrack>
        <SliderInputContainer
          type='range'
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleChange}
          disabled={disabled}
        />
      </SliderContainer>
    </StackContainer>
  );
};

export default SliderInput;
